import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../constants';

export function useGetUsers() {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        async function getUsers() {
            setIsLoading(true);
            setIsError(false);
            try{
                const response = await axios.get(`${API_BASE_URL}/users?populate=*`)
                setUsers(response.data);
            } catch(error) {
                console.error(error)
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }
        getUsers();
    }, [])
    return { users, isLoading, isError }
}

export default useGetUsers;